import { Card, CardContent, Container, Grid, Hidden } from "@material-ui/core";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import useTabs from "../../hooks/useTabs";
import { useTranslation } from "../../hooks/useTranslation";
import useValidation from "../../hooks/useValidation";
import {dataSetConfig, dataSetSearch, isLoadingUserData} from "../../redux/actions/dataAction";
import ManualSearchForm from "../../shared/ManualSearchForm/ManualSearchForm";
import { items } from "../../utils/Items";
import Dialog from "../common/Dialog";
import MenuOption from "../MenuOption/MenuOption";
import { useStyles } from "./PrincipalStyles";
import {useStore} from "../../hooks/useStore";

const Principal = () => {
  const classes = useStyles();
  const [openModal, setOpenModal] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { addTab, autoChangeTab } = useTabs();
  const { isLoadUserTab } = useValidation();
  const { dataStore } = useStore();

  const handleModalOpen = () => {
    setOpenModal(true);
  };

  const handleModalClose = () => {
    setOpenModal(false);
  };
  const onSearchSubmit = (dni: string, countryCode: string) => {
    if (dataStore.isLoadingUserData) return;
    dispatch(isLoadingUserData(true));
    isLoadUserTab({ dni, countryCode }).then((response) => {
      if (response.isLoad) {
        autoChangeTab(response.tabIndex);
      } else {
        dispatch(dataSetSearch({ dni, countryCode }));
        dispatch(dataSetConfig({ eventType: "in" }));
        addTab(dni);
      }
    })
  };

  return (
    <div className={classes.container}>
      <Hidden smDown>
        <Container
          maxWidth="xs"
          className={classes.center + " " + classes.container}
        >
          <Card>
            <CardContent>
              <ManualSearchForm onSubmit={onSearchSubmit} />
            </CardContent>
          </Card>
        </Container>
      </Hidden>
      <Hidden mdUp>
        <Grid
          container
          direction="row"
          justifyContent="space-evenly"
          alignItems="center"
          style={{ height: "100%" }}
        >
          {items.map((item, index) => (
            <Grid item xs={12} key={index} className={classes.center}>
              {item.modal !== undefined && item.modal ? (
                <MenuOption
                  key={index}
                  route={item.href}
                  text={t(item.bundleTitle)}
                  iconUrl={item.src}
                  keys={item.keys}
                  modalOpen={handleModalOpen}
                  showBadge={item.showBadge}
                  open={true}
                />
              ) : (
                <MenuOption
                  key={index}
                  route={item.href}
                  text={t(item.bundleTitle)}
                  keys={item.keys}
                  iconUrl={item.src}
                  showBadge={item.showBadge}
                  open={true}
                />
              )}
              {item.modal !== undefined && item.modal ? (
                <Dialog open={openModal}>
                  <ManualSearchForm
                    onSubmit={onSearchSubmit}
                    onCancel={handleModalClose}
                  />
                </Dialog>
              ) : null}
            </Grid>
          ))}
        </Grid>
      </Hidden>
    </div>
  );
};

export default Principal;
